import { __awaiter } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { marked } from 'marked';
import { useRef, useMemo, useEffect } from 'react';
import { useLlmView } from '../../../useLlm/useLlmView.js';

const Text = props => {
  const {
    send
  } = useLlmView(state => state.actions);
  const chunkIndex = props.chunkIndex !== undefined ? props.chunkIndex : -1;
  const htmlRef = useRef(null);
  const {
    html,
    hasBlockElements
  } = useMemo(() => {
    marked.use({
      renderer: {
        link(href, title, text) {
          return `<a class="llm__text-link" href="${href}" target="_blank" rel="noreferrer"
          ${title ? `title="${title}"` : ''}
          onclick="javascript:event.preventDefault(),window.open(event.currentTarget.href);">
            ${text}
          </a>`;
        },
        image(href, title, text) {
          return `<a class="llm__text-img" href="${href}" target="_blank" rel="noreferrer"
          onclick="javascript:event.preventDefault(),window.open(event.currentTarget.href);">
            <img src="${href}"${title ? ` title="${title}"` : ''} alt="" />
          </a>`;
        }
        /*
        html(html: string, block?: boolean) {
          console.log('html', html);
          return html;
        },
        */
      }
    });
    let hasBlockElements = false;
    const html = marked.parse(props.body, {
      walkTokens: token => {
        // console.log('walkTokens', token);
        if (!['text', 'strong', 'em', 'paragraph', 'span', 'space'].includes(token.type)) {
          hasBlockElements = true;
        }
      }
    });
    return {
      html,
      hasBlockElements
    };
  }, [props.body]);
  useEffect(() => {
    let pills = [];
    if (htmlRef.current) {
      pills = Array.from(htmlRef.current.querySelectorAll('.llm__pill'));
    }
    const pillClickHandler = event => __awaiter(void 0, void 0, void 0, function* () {
      if (event.currentTarget) {
        yield send(event.currentTarget.innerText, response => {
          // console.log('Suggestions.onMessage', response.chunks);
        }, response => {
          // console.log('Suggestions.onEnd', response);
        });
      }
    });
    pills.forEach(x => x.addEventListener('click', pillClickHandler));
    return () => {
      pills.forEach(x => x.removeEventListener('click', pillClickHandler));
    };
  }, [props.body, send]);
  const isHeading = chunkIndex === 0 && !hasBlockElements;
  return jsx("div", {
    className: "llm__text",
    children: isHeading ? jsx("h2", {
      ref: htmlRef,
      className: "llm__text-body",
      "data-text": true,
      dangerouslySetInnerHTML: {
        __html: html
      }
    }) : jsx("div", {
      ref: htmlRef,
      className: "llm__text-body",
      "data-text": true,
      dangerouslySetInnerHTML: {
        __html: html
      }
    })
  });
};

export { Text };
//# sourceMappingURL=text.js.map
